import * as React from 'react';
import classnames from 'classnames';
import { StockIndicator } from '@grandvisionhq/common';
import { useFeatureToggles, useIntl } from '@grandvisionhq/state';
import { getEyeLabel } from '../utils.js';
import { useCLEcommContext } from '../../../../context/CLEcommContext.js';

const CLStockIndicator = ({ eyeSideId , className  })=>{
    const { isContactLensStockEnabled  } = useFeatureToggles();
    const intl = useIntl();
    const { state  } = useCLEcommContext();
    const eyeLabel = eyeSideId !== 'both' ? getEyeLabel(intl, eyeSideId) : undefined;
    const { stockIndicatorStatus  } = state.configurator[eyeSideId];
    if (!isContactLensStockEnabled) {
        return null;
    }
    /**
   * Render an empty wrapper when there is no status, so that the required space is reserved.
   * When there is a status, the page should not jump when the status is displayed.
   */ return /*#__PURE__*/ React.createElement("div", {
        className: classnames('cl-stock-indicator', className)
    }, stockIndicatorStatus && /*#__PURE__*/ React.createElement(React.Fragment, null, eyeLabel && /*#__PURE__*/ React.createElement("div", {
        className: "cl-stock-indicator__screenreader-text",
        "data-t": "cl-stock-indicator__screenreader-text"
    }, eyeLabel, ":"), /*#__PURE__*/ React.createElement(StockIndicator, {
        status: stockIndicatorStatus
    })));
};

export { CLStockIndicator };
//# sourceMappingURL=CLStockIndicator.js.map
